import React, { ReactElement } from 'react';
import MenuItem from '@material-ui/core/MenuItem';
import { lowerCase, sentenceCase } from 'globals/utils';
import FsFilterArrowIcon from 'ui-elements/icons/FsFilterArrow';
import { FsDefaultInputProps } from 'ui-elements/form-elements/FsDefaultInput/FsDefaultInput';
import FsSimpleInput from '../FsDefaultInput';
import { getIconStyle } from './FsDefaultSelect.style';

interface FsDefaultSelectOptionProps {
  label?: string;
  value: string | number;
}

type FsDefaultSelectProps = FsDefaultInputProps & {
  options: Array<FsDefaultSelectOptionProps>;
  optionCase?: 'lc' | 'sc';
};

const FsDefaultSelect: React.FC<FsDefaultSelectProps> = ({
  children,
  options = [],
  optionCase = 'lc',
  ...otherInputProps
}) => {
  const iconStyle = getIconStyle();
  return (
    <FsSimpleInput
      {...otherInputProps}
      SelectProps={{
        IconComponent: ({ className, props }): ReactElement => (
          <i
            {...props}
            className={`material-icons ${className}`}
            style={iconStyle}
          >
            <FsFilterArrowIcon />
          </i>
        ),
      }}
      select
    >
      {options.map(({ label, value }) => (
        <MenuItem key={value} value={value}>
          {optionCase === 'lc'
            ? lowerCase(`${label || value}`)
            : sentenceCase(`${label || value}`)}
        </MenuItem>
      ))}
    </FsSimpleInput>
  );
};

export default FsDefaultSelect;
